export default __webpack_public_path__ + "static/media/nft2a.f3f9b815.png";